var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card col-12 bestaetigung",class:{'vgh-blau-bg': _vm.mandant === 1,
     'oesa-gruen-bg': _vm.mandant === 3,
     'oevo-blau-bg': _vm.mandant === 5}},[_c('div',{staticClass:"card-body"},[(_vm.success)?_c('em',{staticClass:"fa-solid fa-check-circle"}):(!_vm.success)?_c('em',{staticClass:"fa-solid fa-exclamation-triangle"}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }